import { animate, style, transition, trigger } from '@angular/animations';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  signal,
  ViewChild,
} from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { finalize, firstValueFrom, forkJoin, map, Observable, of, startWith } from 'rxjs';
import { DialogFiltroGenericoComponent } from 'src/app/components/dialog-filtro-generico/dialog-filtro-generico.component';
import { DialogPromptAiComponent } from 'src/app/components/dialog-prompt-ai/dialog-prompt-ai.component';
import { Filters } from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import { Padre } from 'src/app/components/select-custom/select-custom.component';
import { SpinnerOverlayComponent } from 'src/app/components/spinner-overlay/spinner-overlay.component';
import { TabellaDinamica } from 'src/app/components/tabella-cfg-dinamica/tabella-cfg-dinamica.component';
import {
  DialogImportazioneData,
  DialogImportazioneExcelComponent,
} from 'src/app/page/analisi-materialita/stakeholder/dialog/dialog-importazione-excel/dialog-importazione-excel.component';
import { ESRS, ESRSService } from 'src/app/services/ESRS/esrs.service';
import { KPI, KPIService } from 'src/app/services/KPI/kpi.service';
import { AmbitiService, Ambito } from 'src/app/services/ambiti/ambiti.service';
import {
  AzioneBP,
  AzioneEBuonaPraticaService,
} from 'src/app/services/azione-e-buona-pratica/azione-e-buona-pratica.service';
import {
  Certificazione,
  CertificazioniService,
} from 'src/app/services/certificazioni/certificazioni.service';
import { Impatto, ImpattoService } from 'src/app/services/impatto/impatto.service';
import { ImpegniService, Impegno } from 'src/app/services/impegni/impegni.service';
import { Obiettivo, PianoService } from 'src/app/services/piano/piano.service';
import { Settore, SettoriService, SottoSettore } from 'src/app/services/settori/settori.service';
import {
  StandardRendicontazioneService,
  STDR,
} from 'src/app/services/standard-rendicontazione/standard-rendicontazione.service';
import {
  AreeTematica,
  isTematicaQuestionario,
  ModalitaTematica,
  SDGS,
  Tematica,
  TematicheService,
} from 'src/app/services/tematiche/tematiche.service';
import { TipoElemento, UtilityService } from 'src/app/services/utility/utility.service';
import { DialogCfgRisposteTematicaComponent } from './dialog-cfg-risposte-tematica/dialog-cfg-risposte-tematica.component';
import { DialogCheckEsrsComponent } from './dialog-check-esrs/dialog-check-esrs.component';
import { DialogCreaTabellaDinamicaComponent } from './dialog-crea-tabella-dinamica/dialog-crea-tabella-dinamica.component';
import {
  NormaRispostaVsme,
  NormaVsmeBottomsheetComponent,
} from './norma-vsme-bottomsheet/norma-vsme-bottomsheet.component';

@Component({
  selector: 'app-dialog-crea-cfg-tematica',
  templateUrl: './dialog-crea-cfg-tematica.component.html',
  styleUrls: ['./dialog-crea-cfg-tematica.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [style({ opacity: 0 }), animate('0.3s', style({ opacity: 1 }))]),
      transition(':leave', [animate('0.3s', style({ opacity: 0 }))]),
    ]),
  ],
  standalone: false,
})
export class DialogCreaCfgTematicaComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;
  @ViewChild('inputSottoSettori') inputSottoSettori!: ElementRef<HTMLInputElement>;

  public isTabVsme = signal(false);

  public mostraNote: boolean = false;
  private objStdrOriginale: STDR[] = [];

  public arrayAzioneBPAutoCompelte: AzioneBP[] = [];
  public arrayKpiAutoCompelte: KPI[] = [];

  public isKpi = true;
  public isAzione = true;
  public isSottoRisp = true;
  public arrayAzioneRisp: AzioneBP[] = [];
  public espandi = false;
  public arrayAmbiti: Ambito[] = [];
  public arrayAree: AreeTematica[] = [];

  public arraySdgs: SDGS[] = [];

  public arraySettori: Settore[] = [];
  public settoriPerIdSottosettore: { [key: string]: Settore | undefined } = {};

  public arrayImpattiSelFiltrati: Impatto[] = [];
  public arrayImpattiSel: Impatto[] = [];
  public arrayImpattiDisponibili: Impatto[] = [];
  public loadingImpDisp: boolean = true;

  public arrayImpegniSelFiltrati: Impatto[] = [];
  public arrayImpegniSel: Impatto[] = [];
  public arrayImpegni: Impegno[] = [];

  public arrayKpiSelFiltrati: KPI[] = [];
  public arrayKpiSel: KPI[] = [];
  public arrayKpi: KPI[] = [];

  public arrayCertificazioniSelFiltrati: Certificazione[] = [];
  public arrayCertificazioniSel: Certificazione[] = [];
  public arrayCertificazioni: Certificazione[] = [];

  public arrayObiettiviSelFiltrati: Obiettivo[] = [];
  public arrayObiettiviSel: Obiettivo[] = [];
  public arrayObiettivi: Obiettivo[] = [];

  public arrayEsrsSelFiltrati: ESRS[] = [];
  public arrayEsrsSel: ESRS[] = [];
  public arrayEsrs: ESRS[] = [];

  public arrayAzioneBPSelFiltrati: AzioneBP[] = [];
  public arrayAzioneBPSel: AzioneBP[] = [];
  public arrayAzioneBP: AzioneBP[] = [];
  public areaSelezionata: boolean = false; //nascondi e mostra tooltip
  public searchValue: string = '';

  /* Form Controls */
  public formTematiche = new FormGroup({
    /* Id */
    id: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    /* chiave */
    chiave: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    /* tipo */
    tipo: new FormControl<string | undefined>(undefined, {
      nonNullable: true,
      validators: [],
    }),
    /* codice */
    nomeBreve: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
    /* domanda */
    domanda: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),
    /* descrizione */
    descrizione: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, UtilityService.blankValidator],
    }),

    /* SDGS */
    sdgs: new FormControl<SDGS[]>([], {
      nonNullable: true,
      validators: [],
    }),

    /* note */
    note: new FormControl<string>(''),
    idsAmbiti: new FormControl<string[]>([], {
      nonNullable: true,
      validators: [Validators.required],
    }),
    aree: new FormControl<string[]>([], {
      nonNullable: true,
      validators: [Validators.required],
    }),
    azioni: new FormControl<AzioneBP[]>([], {
      nonNullable: true,
      validators: [],
    }),
    impatti: new FormControl<Impatto[]>([], {
      nonNullable: true,
      validators: [],
    }),
    impegni: new FormControl<Impegno[]>([], {
      nonNullable: true,
      validators: [],
    }),
    kpis: new FormControl<KPI[]>([], {
      nonNullable: true,
      validators: [],
    }),
    certificazioni: new FormControl<Certificazione[]>([], {
      nonNullable: true,
      validators: [],
    }),
    obiettivi: new FormControl<Obiettivo[]>([], {
      nonNullable: true,
      validators: [],
    }),
    esrs: new FormControl<ESRS[]>([], {
      nonNullable: true,
      validators: [],
    }),

    opzioni: new FormArray<FormGroup<{ [key: string]: FormControl<any> }>>([]),
    risposteVsme: new FormArray<FormGroup<{ [key: string]: FormControl<any> }>>([]),

    index: new FormControl<number | undefined>(undefined, {
      nonNullable: true,
      validators: [Validators.pattern('^[0-9]*$'), Validators.min(0), Validators.max(999999999999)],
    }),

    sottoSettori: new FormControl<SottoSettore[]>([]),

    minLivelloRispostaAutomatica: new FormControl<number | undefined>(undefined),
    modalita: new FormControl<ModalitaTematica>('DUE_DILIGENCE', { nonNullable: true }),
    multirisposta: new FormControl<boolean>(false, { nonNullable: true }),
    idAzienda: new FormControl<string | null>(null),
  });

  public stdr = new FormControl<Padre[]>([]);
  public compliance = new FormControl<Padre[]>([]);

  public formControlChipSottoSettori = new FormControl<string>('');

  public sottoSettoriFiltrati!: Observable<Settore[]>;

  /**
   * Volori del filtro valorizzati dalla dialog del filtro
   */
  private _valoriFiltro: Filters[] = [];
  private _valoriFiltroSelezionati: Filters[] = [];

  @Input()
  get valFiltri(): Filters[] {
    return this._valoriFiltro;
  }
  /**
   * Filtri impostati da iterfaccia
   */
  private _filtri: { [key: string]: any }[] = [];

  get idTematica() {
    return this.formTematiche.get('id')?.value ?? this.data?.tematica?.id ?? null;
  }
  get isTematicaAziendale(): boolean {
    return !!(this.data?.idAzienda || this.formTematiche.get('idAzienda')?.value);
  }
  constructor(
    private readonly impattoService: ImpattoService,
    public dialogRef: MatDialogRef<DialogCreaCfgTematicaComponent>,
    private readonly tematicheService: TematicheService,
    private readonly utilityService: UtilityService,
    private readonly ambitiService: AmbitiService,
    private readonly impegniService: ImpegniService,
    private readonly kpiService: KPIService,
    private readonly azioniBPService: AzioneEBuonaPraticaService,
    private readonly certificazioniService: CertificazioniService,
    private readonly pianoService: PianoService,
    private readonly esrsService: ESRSService,
    private readonly _bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    private readonly settoriService: SettoriService,
    private readonly stdrService: StandardRendicontazioneService,
    private readonly cdRef: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      tematica: Tematica;
      idAzienda?: string;
      idSettore?: string;
      idAmbito?: string;
    },
  ) {
    this.getStdr();
  }

  async ngAfterViewInit(): Promise<void> {
    await this._datiIniziali();
    if (this.isTematicaAziendale) {
      this.manageTematicaAziendale();
    }
    this.cdRef.detectChanges(); // Forza il rilevamento delle modifiche
  }

  /**
   * Compara due record per il campo "codice"
   *
   * @param elem1
   * @param elem2
   * @returns
   */
  compareByChiave(elem1: SDGS, elem2: SDGS): boolean {
    return elem1.chiave === elem2.chiave;
  }

  /**
   * Compara due record per il campo "id"
   *
   * @param elem1
   * @param elem2
   * @returns
   */
  compareById(elem1: any, elem2: any): boolean {
    return elem1.id === elem2.id; // Sostituisci "id" con la proprietà univoca delle categorie
  }

  mostraNoteFn() {
    this.mostraNote = !this.mostraNote;
  }

  /**
   * Mappo l'oggetto per back-end per quanto riguarda le sottoopzioni. Usato per mandare struttura corretta al BE
   */
  mapOggettoPerBe() {
    let stdrMerged;
    let complianceMerged;

    this.stdrService
      .mergeSelectedStdr(this.stdr.getRawValue() as any, this.objStdrOriginale)
      .subscribe((mergedResult) => {
        stdrMerged = mergedResult.filter((padre) => !padre.compliance);
      });

    this.stdrService
      .mergeSelectedStdr(this.compliance.getRawValue() as any, this.objStdrOriginale)
      .subscribe((mergedResult) => {
        complianceMerged = mergedResult.filter((padre) => padre.compliance);
      });

    let newForm = {
      ...this.formTematiche.getRawValue(),
      compliance: complianceMerged,
      stdr: stdrMerged,
    };

    if (newForm?.opzioni) {
      newForm.opzioni = this.normalizzaSottoOpzioni(newForm.opzioni);
    }

    if (newForm?.risposteVsme) {
      newForm.risposteVsme = this.normalizzaSottoOpzioni(newForm.risposteVsme);
    }

    return newForm;
  }

  /**
   * Normalizza dati
   * @param formName
   * @returns
   */
  normalizzaSottoOpzioni(formName: any) {
    return formName.map((risposte: any) => {
      // Normalizzo i valori nelle sotto opzioni, poichè per le checkbox il valore è stringa invece per gli altri è tipo oggetto.
      const sottoOpzioniValori = risposte['sottoOpzioni'].map((sottoOpzione: any) => ({
        ...(sottoOpzione?.tipo === 'checkbox'
          ? { valore: sottoOpzione?.valore, id: sottoOpzione?.id }
          : { ...sottoOpzione?.valore }),
        tipo: sottoOpzione?.tipo,
        punteggio: sottoOpzione?.punteggio,
        moduloCompleto: sottoOpzione?.moduloCompleto,
      }));

      return {
        ...risposte,
        sottoOpzioni: sottoOpzioniValori,
      };
    });
  }

  /**
   * Se ho una temtaica VSME e ho  configurato delle risposte, queste risposte devono avere obbligatorialmente una sotto risposta
   * @param nuovoOggetto oggetto pre salvataggio
   * @returns
   */
  private controlloSottoRisposteVsme(nuovoOggetto: any): boolean {
    const isRispostaSenzaSottoRisposta = nuovoOggetto.risposteVsme.some(
      (risp: any) => !risp.sottoOpzioni.length,
    );

    if (!isRispostaSenzaSottoRisposta) {
      return false;
    }

    this.utilityService.openDialog({
      titolo: 'Attenzione',
      descrizione: 'Inserisci una o più sotto risposte per le risposte VSME.',
      bottoni: [{ nome_btn: 'Chiudi' }],
    });

    return true;
  }

  private _controlloPreSalvataggioNotPassed(nuovoOggetto: any): boolean {
    if (nuovoOggetto?.aree?.includes('autovalutazioni') && !nuovoOggetto?.opzioni?.length) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Inserisci una o più risposte con area Autovalutazioni',
        bottoni: [{ nome_btn: 'Chiudi' }],
      });

      return true;
    }

    if (this.isVsme() && !nuovoOggetto?.risposteVsme?.length) {
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Inserisci una o più risposte per lo Standard di rendicontazione VSME',
        bottoni: [{ nome_btn: 'Chiudi' }],
      });

      return true;
    }

    /* Controllo che se ho il tab VSME allora devo avere almeno una sotto risposta nella risposta creta */
    if (this.controlloSottoRisposteVsme(nuovoOggetto)) {
      return true;
    }

    /* Controllo i campi obbligaotri */
    if (this.formTematiche.invalid) {
      Object.values(this.formTematiche.controls).forEach((control) => {
        control.markAsTouched();
      });

      this._ctrFormRisposte('opzioni');
      this._ctrFormRisposte('risposteVsme');

      this.utilityService.openSnackBar('Form non valida', '', {
        duration: 2000,
        panelClass: ['red-snackbar'],
      });
      return true; // form non corretta
    }

    return false;
  }

  /**
   * Funzione di salvataggio
   * @returns
   */
  public async salva(): Promise<boolean> {
    this.formTematiche.get('impatti')?.setValue(this.arrayImpattiSel);
    this.formTematiche.get('impegni')?.setValue(this.arrayImpegniSel);
    this.formTematiche.get('kpis')?.setValue(this.arrayKpiSel);
    this.formTematiche.get('azioni')?.setValue(this.arrayAzioneBPSel);
    this.formTematiche.get('certificazioni')?.setValue(this.arrayCertificazioniSel);
    this.formTematiche.get('obiettivi')?.setValue(this.arrayObiettiviSel);
    this.formTematiche.getRawValue();

    let nuovoOggetto = this.mapOggettoPerBe();

    if (this._controlloPreSalvataggioNotPassed(nuovoOggetto)) {
      return false;
    }

    this.spinnerOver.show();

    try {
      const id = nuovoOggetto?.id;

      let result: any;

      if (id) {
        result = await firstValueFrom(this.tematicheService.putTematica(id, nuovoOggetto));
        this.utilityService.openSnackBar('Aggiornamento effettuato ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
      } else {
        result = await firstValueFrom(this.tematicheService.postTematiche(nuovoOggetto));
        this.utilityService.openSnackBar('Salvataggio effettuato ', '', {
          duration: 2000,
          panelClass: ['success-snackbar'],
        });
      }
      if (result?.body) {
        this._initTematica(result.body);
      }

      return true; // OK Salvataggio
    } catch (error) {
      console.error('Errore durante il salvataggio delle tematiche:', error);
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel salvataggio delle tematiche',
        bottoni: [{ nome_btn: 'Chiudi' }],
      });

      return false; // errore
    } finally {
      this.spinnerOver.hide();
    }
  }

  private _ctrFormRisposte(formName: string) {
    /* Controllo validazione dei campi form dentro al campo opzioni. E' un formArray */
    const form = this.formTematiche.get(formName);

    if (form instanceof FormArray || form instanceof FormGroup) {
      Object.values(form.controls).forEach((control) => {
        if (control.invalid) {
          // Se il control ha controlli figli (come un FormGroup o FormArray), itera su di essi.
          if ((control as FormGroup | FormArray).controls) {
            // Controllo annidato
            Object.values((control as FormGroup | FormArray).controls).forEach((subControl) =>
              subControl.markAsTouched(),
            );
          } else {
            // Se il control è un FormControl, puoi semplicemente fare markAsTouched.
            control.markAsTouched();
          }
        }
      });
    }
  }

  addRiga(formArrayRisposte: FormArray, sottoOpzione?: boolean, isVsme?: boolean) {
    this.espandi = true;
    if (sottoOpzione) {
      this.isSottoRisp = true;
      this.isKpi = false;
      this.isAzione = false;
    } else {
      this.isSottoRisp = true;
      this.isKpi = true;
      this.isAzione = true;
    }

    const formRisposta = new FormGroup({
      chiave: new FormControl<string>(''),
      id: new FormControl<string>(''),
      note: new FormControl<string>(''),
      valore: new FormControl<string>('', [Validators.required, UtilityService.blankValidator]),
      nc: new FormControl<boolean | undefined>(undefined),
      descrizione: new FormControl<string>(''),
      punteggio: new FormControl<number | undefined>(
        undefined,
        isVsme ? [] : [Validators.required],
      ),
      sottoOpzioni: new FormArray([]),
      tipo: new FormControl<string>(sottoOpzione ? 'checkbox' : ''),
      moduloCompleto: new FormControl<boolean>(false),
      codiceNormaVsme: new FormControl<string>(''),
      descrizioneNormaVsme: new FormControl<string>(''),
    });

    // Solo per le risposte dell'assessment: scelta singola/multipla delle sottorisposte (Questionario)
    if (!sottoOpzione && !isVsme) {
      (formRisposta as FormGroup).addControl(
        'multirisposta',
        new FormControl<boolean>({ value: false, disabled: !this.isQuestionario }),
      );
    }

    formArrayRisposte.push(formRisposta);
    this.cdRef.detectChanges();
  }

  elimina(formArrayRisposte: FormArray, index: number) {
    formArrayRisposte.removeAt(index);
    if (!formArrayRisposte.length) {
      this.isSottoRisp = true;
      this.isKpi = true;
      this.isAzione = true;
    }
  }

  /*GESTIONE AUTOCOMPLETE DEI KPI NELLA TAB RISPOSTE  */
  getKPIAutoComplete = (id: any, txtRicerca: string) => {
    let records: KPI[] = [];

    if (id) {
      records = this.arrayKpiAutoCompelte.filter((option) => option.id?.toLowerCase() === id);
    } else if (txtRicerca) {
      records = this._filterKpi(txtRicerca);
    } else {
      records = this.arrayKpiAutoCompelte.slice();
    }

    return of(records);
  };

  displayFn(kpi: KPI): string {
    return kpi?.descrizione ?? '';
  }

  private _filterKpi(categoria: string): KPI[] {
    const filterValue = categoria.toLowerCase();
    return this.arrayKpiAutoCompelte.filter((option) =>
      option.descrizione?.toLowerCase().includes(filterValue),
    );
  }

  /*GESTIONE AUTOCOMPLETE DEI KPI NELLA TAB RISPOSTE  */
  getAzioneAutoComplete = (id: any, txtRicerca: string) => {
    let records: AzioneBP[] = [];

    if (id) {
      records = this.arrayAzioneBPAutoCompelte.filter((option) => option.id?.toLowerCase() === id);
    } else if (txtRicerca) {
      records = this._filterAzione(txtRicerca);
    } else {
      records = this.arrayAzioneBPAutoCompelte.slice();
    }

    return of(records);
  };

  displayFnAzione(azione: AzioneBP): string {
    return azione?.titolo ?? '';
  }

  private _filterAzione(categoria: string): AzioneBP[] {
    const filterValue = categoria.toLowerCase();
    return this.arrayAzioneBPAutoCompelte.filter((option) =>
      option.titolo?.toLowerCase().includes(filterValue),
    );
  }

  onTabChange(event: MatTabChangeEvent) {
    this.isTabVsme.set(false);
    // Quando cambio la tab ricarcio la lista degli Disponibli
    // questo per pulire i filtri poichè rimanevano sporchi con la tab precedente.
    this._valoriFiltro = [];
    this._valoriFiltroSelezionati = [];
    switch (event.tab.textLabel) {
      case 'VSME':
        this.isTabVsme.set(true);
        break;
      case 'Impatti':
        this._getImpatti();
        break;
      case 'Impegni':
        this._getImpegni();
        break;
      case 'Buone Pratiche':
        this._getAzioniBP();
        break;
      case 'KPI':
        this._getkPI();
        break;
      case 'Certificazioni':
        this._getCertificazioni();
        break;
      case 'Obiettivi':
        this._getObiettivi();
        break;
      case 'ESRS':
        this._getEsrs();
        break;
      default:
        break;
    }
  }

  drop(event: CdkDragDrop<any[]>, tabForm: string) {
    const rules = this.formTematiche.get(tabForm) as FormArray;

    const currentGroup = rules.at(event.previousIndex);
    rules.removeAt(event.previousIndex);
    rules.insert(event.currentIndex, currentGroup);
  }

  dropSotto(event: CdkDragDrop<any[]>, formArraySotto: FormArray) {
    const rules = formArraySotto;

    const currentGroup = rules.at(event.previousIndex);
    rules.removeAt(event.previousIndex);
    rules.insert(event.currentIndex, currentGroup);
  }

  private _getAmbiti() {
    let filtroAmbito: Filters[] = [];

    // Se sono in una tematica aziendale, devo filtrare gli ambiti per settore, altrimenti prendo tutti gli ambiti
    if (this.isTematicaAziendale && this.data?.idSettore) {
      filtroAmbito.push({
        values: [this.data.idSettore],
        operator: 'eq',
        chiave: 'idSettore',
      });
    }

    return this.ambitiService.getAmbiti(0, 1000, '', filtroAmbito, [
      {
        chiave: 'index',
        sort: 'asc',
      },
      {
        chiave: 'descrizione',
        sort: 'asc',
      },
    ]);
  }

  private _initTematica(tematica: Tematica) {
    Object.keys(tematica).forEach((value, index, array) => {
      if (value && (tematica as any)[value]) {
        if (value === 'opzioni' || value === 'risposteVsme') {
          const isVsme: boolean = value === 'risposteVsme';

          const opzOrRisposteVsme = (tematica as any)[value];

          (this.formTematiche.get(value) as FormArray).clear();

          opzOrRisposteVsme.forEach((opz: any) => {
            const formRisposta = new FormGroup({
              chiave: new FormControl<string>(opz.chiave ?? ''),
              id: new FormControl<string>(opz.id ?? ''),
              note: new FormControl<string>(opz.note ?? ''),
              valore: new FormControl<string>(opz.valore ?? '', [
                Validators.required,
                UtilityService.blankValidator,
              ]),
              descrizione: new FormControl<string>(opz.descrizione ?? ''),
              punteggio: new FormControl<number | undefined>(
                opz.punteggio,
                isVsme ? [] : [Validators.required],
              ),
              nc: new FormControl<boolean>(opz.punteggio === undefined || opz.punteggio === null),
              sottoOpzioni: new FormArray([]),
              tipo: new FormControl<string>(opz.tipo ?? ''),
              codiceNormaVsme: new FormControl<string>(opz.codiceNormaVsme ?? ''),
              descrizioneNormaVsme: new FormControl<string>(opz.descrizioneNormaVsme ?? ''),
              moduloCompleto: new FormControl<boolean>(opz.moduloCompleto),
            });

            // Lo stato abilitato/disabilitato viene allineato alla modalità da _applicaStatoModalita
            if (!isVsme) {
              (formRisposta as FormGroup).addControl(
                'multirisposta',
                new FormControl<boolean>(opz.multirisposta ?? false),
              );
            }

            if (opz.punteggio === undefined || opz.punteggio === null) {
              formRisposta.get('punteggio')?.disable();
            } else {
              formRisposta.get('punteggio')?.enable();
            }

            if (opz.sottoOpzioni?.length) {
              (formRisposta.get('sottoOpzioni') as FormArray).setValue([]);
              for (const stOpzione of opz.sottoOpzioni) {
                let formSottopz: any;
                if (stOpzione.tipo === 'kpi') {
                  formSottopz = new FormGroup({
                    valore: new FormControl<KPI | undefined>(stOpzione, {
                      nonNullable: true,
                      validators: [Validators.required, UtilityService.blankValidator],
                    }),
                    punteggio: new FormControl<number | undefined>(
                      stOpzione.punteggio,
                      isVsme ? [] : [Validators.required],
                    ),
                    nc: new FormControl<boolean>(
                      opz.punteggio === undefined || opz.punteggio === null,
                    ),
                    sottoOpzioni: new FormArray([]),
                    tipo: new FormControl<string>(stOpzione.tipo ?? ''),
                    moduloCompleto: new FormControl<boolean>(stOpzione.moduloCompleto),
                  });
                } else if (stOpzione.tipo === 'azione') {
                  formSottopz = new FormGroup({
                    valore: new FormControl<AzioneBP | undefined>(stOpzione, {
                      nonNullable: true,
                      validators: [Validators.required, UtilityService.blankValidator],
                    }),
                    nc: new FormControl<boolean>(
                      opz.punteggio === undefined || opz.punteggio === null,
                    ),
                    punteggio: new FormControl<number | undefined>(
                      stOpzione.punteggio,
                      isVsme ? [] : [Validators.required],
                    ),
                    sottoOpzioni: new FormArray([]),
                    tipo: new FormControl<string>(stOpzione.tipo ?? ''),
                    moduloCompleto: new FormControl<boolean>(stOpzione.moduloCompleto ?? ''),
                  });
                } else if (stOpzione.tipo === 'dynamic_table') {
                  /* qui */
                  formSottopz = new FormGroup({
                    valore: new FormControl<TabellaDinamica | undefined>(stOpzione, {
                      nonNullable: true,
                      validators: [Validators.required, UtilityService.blankValidator],
                    }),
                    nc: new FormControl<boolean>(
                      opz.punteggio === undefined || opz.punteggio === null,
                    ),
                    punteggio: new FormControl<number | undefined>(
                      stOpzione.punteggio,
                      isVsme ? [] : [Validators.required],
                    ),
                    sottoOpzioni: new FormArray([]),
                    tipo: new FormControl<string>(stOpzione.tipo ?? ''),
                    moduloCompleto: new FormControl<boolean>(stOpzione.moduloCompleto),
                  });
                } else if (stOpzione.tipo === 'checkbox' || stOpzione.tipo === '') {
                  formSottopz = new FormGroup({
                    chiave: new FormControl<string>(stOpzione.chiave ?? ''),
                    id: new FormControl<string>(stOpzione.id ?? ''),
                    note: new FormControl<string>(stOpzione.note ?? ''),
                    valore: new FormControl<string>(stOpzione.valore ?? '', [
                      Validators.required,
                      UtilityService.blankValidator,
                    ]),
                    punteggio: new FormControl<number | undefined>(
                      stOpzione.punteggio,
                      isVsme ? [] : [Validators.required],
                    ),
                    nc: new FormControl<boolean>(
                      stOpzione.punteggio === undefined || stOpzione.punteggio === null,
                    ),
                    sottoOpzioni: new FormArray([]),
                    tipo: new FormControl<string>(stOpzione.tipo ?? ''),
                    moduloCompleto: new FormControl<boolean>(stOpzione.moduloCompleto),
                  });
                }

                if (stOpzione.punteggio === undefined || stOpzione.punteggio === null) {
                  formSottopz.get('punteggio')?.disable();
                } else {
                  formSottopz.get('punteggio')?.enable();
                }

                (formRisposta.get('sottoOpzioni') as FormArray).push(formSottopz);
              }
            }

            (this.formTematiche.get(value) as FormArray).push(formRisposta);
          });
        } else if (value === 'datiAmbiti') {
          const ambiti = (tematica as any)[value];

          const arrayIdAmb: string[] = ambiti.map((amb: Ambito) => amb.id);

          this.formTematiche.get('idsAmbiti')?.setValue(arrayIdAmb);
        } else if (value === 'sdgs') {
          this.formTematiche.get('sdgs')?.setValue(
            (tematica?.sdgs || [])
              .map((value) => {
                return this.arraySdgs.find((valueSdgs) => valueSdgs.chiave === value.chiave);
              })
              .filter((value) => !!value) as SDGS[],
          );
        } else if (value === 'sottoSettori') {
          this.formTematiche.get('sottoSettori')?.setValue(tematica?.sottoSettori || []);
        } else {
          this.formTematiche.get(value)?.setValue((tematica as any)[value]);
        }
      }
    });

    // riempio arrayDiImpattiSel per vedere gli impatti selezionati in modifica
    this.arrayImpattiSel = this.formTematiche.get('impatti')?.value as Impatto[];

    //rimuovo gli impatti selezionati da quelli disponibili
    this.arrayImpattiDisponibili = this.arrayImpattiDisponibili.filter(
      (impattoSel) => !this.arrayImpattiSel.some((item2) => impattoSel.id === item2.id),
    );

    // Impatti filtrati (inizialmente nascono uguali )
    this.arrayImpattiSelFiltrati = [...this.arrayImpattiSel]; // array indipendente di memoria

    this.arrayKpiSel = this.formTematiche.get('kpis')?.value as KPI[];
    this.arrayKpi = this.arrayKpi.filter(
      (kpiSel) => !this.arrayKpiSel.some((item2) => kpiSel.id === item2.id),
    );
    this.arrayKpiSelFiltrati = [...this.arrayKpiSel];

    this.arrayImpegniSel = this.formTematiche.get('impegni')?.value as Impegno[];
    this.arrayImpegni = this.arrayImpegni.filter(
      (impegniSel) => !this.arrayImpegniSel.some((item2) => impegniSel.id === item2.id),
    );
    this.arrayImpegniSelFiltrati = [...this.arrayImpegniSel];

    this.arrayAzioneBPSel = this.formTematiche.get('azioni')?.value as AzioneBP[];
    this.arrayAzioneBP = this.arrayAzioneBP.filter(
      (azioneSel) => !this.arrayAzioneBPSel.some((item2) => azioneSel.id === item2.id),
    );
    this.arrayAzioneBPSelFiltrati = [...this.arrayAzioneBPSel];

    this.arrayCertificazioniSel = this.formTematiche.get('certificazioni')
      ?.value as Certificazione[];
    this.arrayCertificazioni = this.arrayCertificazioni.filter(
      (certificazioneSel) =>
        !this.arrayCertificazioniSel.some((item2) => certificazioneSel.id === item2.id),
    );
    this.arrayCertificazioniSelFiltrati = [...this.arrayCertificazioniSel];

    this.arrayObiettiviSel = this.formTematiche.get('obiettivi')?.value as Obiettivo[];
    this.arrayObiettivi = this.arrayObiettivi.filter(
      (obiettivoSel) => !this.arrayObiettiviSel.some((item2) => obiettivoSel.id === item2.id),
    );
    this.arrayObiettiviSelFiltrati = [...this.arrayObiettiviSel];

    this.arrayEsrsSel = this.formTematiche.get('esrs')?.value as ESRS[];
    this.arrayEsrs = this.arrayEsrs.filter(
      (esrsSel) => !this.arrayEsrsSel.some((item2) => esrsSel.id === item2.id),
    );
    this.arrayEsrsSelFiltrati = [...this.arrayEsrsSel];

    // Le risposte sono state ricreate: allineo lo stato abilitato/disabilitato alla modalità
    this._applicaStatoModalita();
  }

  /**
   * True se la tematica in configurazione è in modalità Questionario.
   */
  get isQuestionario(): boolean {
    return isTematicaQuestionario({ modalita: this.formTematiche.controls.modalita.value });
  }

  /**
   * Abilita i campi della modalità corrente e disabilita quelli dell'altra.
   * I campi disabilitati conservano il valore e vengono comunque salvati (getRawValue),
   * così ricambiando modalità la configurazione è già pronta.
   * - Due Diligence: minLivelloRispostaAutomatica attivo, flag multirisposta disabilitati.
   * - Questionario: minLivelloRispostaAutomatica disabilitato, flag multirisposta attivi.
   */
  private _applicaStatoModalita(): void {
    const questionario = this.isQuestionario;

    this._setAbilitato(this.formTematiche.controls.minLivelloRispostaAutomatica, !questionario);
    this._setAbilitato(this.formTematiche.controls.multirisposta, questionario);

    this.formTematiche.controls.opzioni.controls.forEach((risposta) => {
      const multirisposta = risposta.get('multirisposta');
      if (multirisposta) {
        this._setAbilitato(multirisposta, questionario);
      }
    });
  }

  private _setAbilitato(control: AbstractControl, abilitato: boolean): void {
    if (abilitato) {
      control.enable({ emitEvent: false });
    } else {
      control.disable({ emitEvent: false });
    }
  }

  /**
   * Metodo generale che mi fa il drag and drop e sorting su liste filtrate e non.
   * @param event evento del drag & drop su quale azionare
   * @param arrayElementiSel
   * @param arrayElementiSelFiltrati
   * @returns oggetto con gli array calcolati
   */
  dropElementi(
    event: CdkDragDrop<any[]>,
    arrayElementiSel: any[],
    arrayElementiSelFiltrati: any[],
  ) {
    // Calcolo gli elementi nascosti dal filtro
    const elementiNascostiDalFiltro = arrayElementiSel.filter((elem1) => {
      return !arrayElementiSelFiltrati.some((elem2) => elem2.id === elem1.id);
    });

    // Funzione per ottenere indice non filtrato
    const getIndexNonFiltrato = (id: string) =>
      arrayElementiSel.findIndex((elem) => elem?.id === id);

    // Funzione per applicare il filtro iniziale
    const ripristinaFiltro = () => {
      arrayElementiSelFiltrati = arrayElementiSelFiltrati.filter((elem2) => {
        return !elementiNascostiDalFiltro.some((elem1) => elem1.id === elem2.id);
      });
    };

    const isSorting = event.previousContainer === event.container;
    const isAzioneSuSelezionati = event.container.data.every((item1) =>
      arrayElementiSel.some((item2) => item2.id === item1.id),
    );

    // Caso: Comportamento con filtro
    if (elementiNascostiDalFiltro.length) {
      if (isSorting) {
        // Sorting nella lista filtrata

        if (isAzioneSuSelezionati) {
          /*  Mi calcolo Index elemeno sulla lista non filtrata
             Perchè se ho filtrato vuoldire che gli indici in visualizzazione
             non corrispondono più con quelli originali per fare il sorting */
          const idForIdx = arrayElementiSelFiltrati[event.previousIndex]?.id;
          const findIdx = getIndexNonFiltrato(idForIdx);

          moveItemInArray(arrayElementiSel, findIdx, event.currentIndex);
          moveItemInArray(arrayElementiSelFiltrati, event.previousIndex, event.currentIndex);
        } else {
          moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
        // Sono in lista filtrata e faccio drag and drop
      } else if (isAzioneSuSelezionati) {
        // Drag and drop da DISPONIBILI a SELEZIONATI

        /* Prendo l'id dell elemento sopra a quello spostato, Per avere un riferimento di posizione 
           Questo perchè quando sposto un elemento lo posso rilasciare in qualsisi posizione, quindi 
          prendento un indice di riferimento, quando rimuovo i filtri, l'elemento spostato andra sotto quel
          indice di riferimento */
        const idElemSopra = arrayElementiSelFiltrati[event.currentIndex - 1]?.id;

        /* Tovo l'indice corretto per la lista non filtrata. Ovvero se nella lista filtratra ho spostato
         un elemento sotto [id : 1] allora mi prendo l'id del elemento sopra [id 1 - 1] e cerco l'id
         trovato l'id del elemento nella lista non fitlrata mi prendo index di spostamento sommando al indice trovato + 1 */
        const findIdx = getIndexNonFiltrato(idElemSopra) + 1;

        // Mi inserisco l'elemento nella posizione corretta nella lista non filtrata
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          findIdx,
        );

        // Mi inserisco l'elemento anche nella lista filtrata, sul indice selezionato dall'interfaccia perhcè corrisponde.
        arrayElementiSelFiltrati.splice(event.currentIndex, 0, arrayElementiSel[findIdx]);

        // Rimuovo gli elementi nascosti per ritornare al filtro di prima
        ripristinaFiltro();
      } else {
        // Drag and drop da SELEZIONATI a DISPONIBILI

        // Mi trovo l'indice della lista non filtrata, questo perchè event.previousIndex mi risulta l'indice della lista filtrata
        const idxListaNonFiltrata = getIndexNonFiltrato(
          arrayElementiSelFiltrati[event.previousIndex].id,
        );

        //Rimuovo l'elemento che ho spostato dalla lista filtrata
        arrayElementiSelFiltrati = arrayElementiSelFiltrati.filter(
          (item) => item.id !== event.previousContainer.data[idxListaNonFiltrata].id,
        );

        // Trasferisco l'elemento con l'indice corretto
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          idxListaNonFiltrata,
          event.currentIndex,
        );
      }
    } else {
      // Caso: Comportamento regolare senza filtro
      arrayElementiSelFiltrati = arrayElementiSel; // stesso riferimento di memoria

      if (isSorting) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex,
        );
      }
    }

    const obj = {
      arrayElementiSelFiltrati: arrayElementiSelFiltrati,
      arrayElementiSel: arrayElementiSel,
    };

    return obj;
  }

  dropImpatti(event: CdkDragDrop<Impatto[]>) {
    const obj = this.dropElementi(event, this.arrayImpattiSel, this.arrayImpattiSelFiltrati);

    this.arrayImpattiSel = obj.arrayElementiSel;
    this.arrayImpattiSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  dropImpegni(event: CdkDragDrop<Impegno[]>) {
    const obj = this.dropElementi(event, this.arrayImpegniSel, this.arrayImpegniSelFiltrati);

    this.arrayImpegniSel = obj.arrayElementiSel;
    this.arrayImpegniSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  dropKpi(event: CdkDragDrop<KPI[]>) {
    const obj = this.dropElementi(event, this.arrayKpiSel, this.arrayKpiSelFiltrati);

    this.arrayKpiSel = obj.arrayElementiSel;
    this.arrayKpiSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  dropAzioneBP(event: CdkDragDrop<AzioneBP[]>) {
    const obj = this.dropElementi(event, this.arrayAzioneBPSel, this.arrayAzioneBPSelFiltrati);

    this.arrayAzioneBPSel = obj.arrayElementiSel;
    this.arrayAzioneBPSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  dropCertificazioni(event: CdkDragDrop<Certificazione[]>) {
    const obj = this.dropElementi(
      event,
      this.arrayCertificazioniSel,
      this.arrayCertificazioniSelFiltrati,
    );

    this.arrayCertificazioniSel = obj.arrayElementiSel;
    this.arrayCertificazioniSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  dropObiettivi(event: CdkDragDrop<Obiettivo[]>) {
    const obj = this.dropElementi(event, this.arrayObiettiviSel, this.arrayObiettiviSelFiltrati);

    this.arrayObiettiviSel = obj.arrayElementiSel;
    this.arrayObiettiviSelFiltrati = obj.arrayElementiSelFiltrati;
  }

  async dropEsrs(event: CdkDragDrop<ESRS[]>, fromDisponibili?: boolean) {
    if (fromDisponibili && event.previousContainer !== event.container) {
      if (!this.idTematica) {
        const result = await this.salva();

        if (!result) {
          return;
        }
      }

      const elemDroppato = this.arrayEsrs[event.previousIndex];

      const dialogCheckEsrs = this.dialog.open(DialogCheckEsrsComponent, {
        data: {
          domandaTematica: this.formTematiche.get('domanda')?.value,
          esrs: elemDroppato,
          idTematica: this.idTematica,
        },
        panelClass: ['dialog-container'],
        disableClose: false,
        width: '70%',
        maxHeight: '95%',
        height: '95%',
        autoFocus: false,
      });

      dialogCheckEsrs.afterClosed().subscribe((tematica) => {
        if (tematica) {
          const obj = this.dropElementi(event, this.arrayEsrsSel, this.arrayEsrsSelFiltrati);

          this.arrayEsrsSel = obj.arrayElementiSel;
          this.arrayEsrsSelFiltrati = obj.arrayElementiSelFiltrati;

          /******************** DA VEDERE LUINEDI *******************/

          const esrsCorretti = tematica.esrs.filter((esrsTem: ESRS) =>
            this.arrayEsrsSel.some((item) => esrsTem.id === item.id),
          );

          this.formTematiche.get('esrs')?.setValue(esrsCorretti);
        } else {
          return;
        }
      });
    } else {
      const obj = this.dropElementi(event, this.arrayEsrsSel, this.arrayEsrsSelFiltrati);

      this.arrayEsrsSel = obj.arrayElementiSel;
      this.arrayEsrsSelFiltrati = obj.arrayElementiSelFiltrati;

      this.formTematiche.get('esrs')?.setValue(this.arrayEsrsSel);
    }
  }

  public _openDialogCheckEsrs(esrs: ESRS) {
    const dialogCheckEsrs = this.dialog.open(DialogCheckEsrsComponent, {
      data: {
        domandaTematica: this.formTematiche.get('domanda')?.value,
        esrs: esrs,
        idTematica: this.idTematica,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '70%',
      maxWidth: '90%',
      maxHeight: '95%',
      height: '95%',
      autoFocus: false,
    });

    dialogCheckEsrs.afterClosed().subscribe((tematica) => {
      if (tematica) {
        const esrsCorretti = tematica.esrs.filter((esrsTem: ESRS) =>
          this.arrayEsrsSel.some((item) => esrsTem.id === item.id),
        );

        this.formTematiche.get('esrs')?.setValue(esrsCorretti);
      }
    });
  }

  cambioNc(event: any, idx: number) {
    const formOpz: FormGroup = this.formTematiche.controls.opzioni.controls[idx];

    if (event.checked) {
      formOpz.get('punteggio')?.setValue(null);
      formOpz.get('punteggio')?.disable();
    } else {
      formOpz.get('punteggio')?.setValue(0);
      formOpz.get('punteggio')?.enable();
    }
  }

  public async _datiIniziali(): Promise<void> {
    // 1. Setup dei listener sincroni e configurazioni iniziali
    this.setIdAziendaInTematica();

    this.sottoSettoriFiltrati = this.formControlChipSottoSettori.valueChanges.pipe(
      startWith(''),
      map((value) => value ?? ''),
      map((value: string) => (value ? this._filtraSottoSettori(value) : this.arraySettori.slice())),
    );

    // Gestione automatica selezione 'bilanci' se c'è 'survey'
    this.formTematiche.get('aree')?.valueChanges.subscribe((risposta: string[]) => {
      if (risposta?.includes('survey') && !risposta.includes('bilanci')) {
        const valArea = [...risposta, 'bilanci'];
        this.formTematiche.get('aree')?.setValue(valArea, { emitEvent: false });
      }
    });

    this.formTematiche.get('idsAmbiti')?.valueChanges.subscribe(() => {
      this.getSettoriDaAmbiti();
    });

    // Due Diligence / Questionario: abilita i campi della modalità scelta, conservando i valori dell'altra
    this.formTematiche.controls.modalita.valueChanges.subscribe(() => {
      this._applicaStatoModalita();
    });
    this._applicaStatoModalita();

    // 2. Avvio dello spinner
    this.spinnerOver.show();

    try {
      // 3. TRASFORMAZIONE IN PROMISE: Qui il codice si FERMA finché tutte le chiamate non sono finite
      const risp = await firstValueFrom(
        forkJoin({
          ambiti: this._getAmbiti(),
          impDisp: this.impattoService.getImpatti(0, 1000),
          aree: this.tematicheService.getAree(),
          impegni: this.impegniService.getImpegni(0, 1000),
          kpi: this.kpiService.getKPI(0, 1000),
          azioni: this.azioniBPService.getAzioneBP(0, 1000),
          sdgs: this.tematicheService.getSDGS(),
        }),
      );

      // 4. Elaborazione dati (eseguita solo dopo il completamento delle chiamate)

      if (this.isTematicaAziendale && this.data.idAmbito) {
        risp.ambiti.content = risp.ambiti.content.filter(
          (amb: Ambito) => amb.id === this.data.idAmbito,
        );
      }

      this.arrayAmbiti = (risp.ambiti?.content || []).sort((a: any, b: any) => {
        const indexA = a.index ?? Infinity;
        const indexB = b.index ?? Infinity;
        return indexA - indexB;
      });

      this.arrayImpattiDisponibili = risp.impDisp?.content || [];
      this.arrayImpegni = risp.impegni?.content || [];
      this.arrayKpi = risp.kpi?.content || [];
      this.arrayKpiAutoCompelte = [...this.arrayKpi];
      this.arrayAzioneBP = risp.azioni?.content || [];
      this.arrayAzioneBPAutoCompelte = [...this.arrayAzioneBP];
      this.arraySdgs = risp.sdgs || [];
      this.arrayAree = risp.aree || [];

      this.loadingImpDisp = false;

      // 5. Inizializzazione form/dati specifica
      if (this.data?.tematica) {
        this._initTematica(this.data.tematica);
      } else if (this.arrayAree?.length === 1) {
        this.formTematiche.get('aree')?.setValue([this.arrayAree[0].chiave]);
      }
    } catch (err) {
      console.error('Errore durante il caricamento dati iniziali:', err);
      this.utilityService.openDialog({
        titolo: 'Attenzione',
        descrizione: 'Errore nel recupero dei valori',
        bottoni: [{ nome_btn: 'Ok' }],
      });
    } finally {
      // 6. Chiusura spinner e refresh finale
      this.spinnerOver.hide();
      this.cdRef.detectChanges();
    }
  }

  private _filtraSottoSettori(value: string) {
    return this.arraySettori
      .map((settore): Settore => {
        return {
          ...settore,
          sottoSettori: settore.sottoSettori.filter((sottoSett) => {
            return (sottoSett.titolo || '').toLowerCase().indexOf(value?.toString() || '') >= 0;
          }),
        };
      })
      .filter((settore) => !!settore?.sottoSettori?.length);
  }

  private getStdr() {
    let isCreazione = !this.idTematica;

    this.tematicheService
      .getStdr(this.idTematica, isCreazione)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito: STDR[]) => {
          this.objStdrOriginale = esito;

          this.compliance.setValue(this.stdrService.setOggettoSelectionCompliance(esito));

          this.stdr.setValue(this.stdrService.setOggettoSelectionStdr(esito));
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  private getSettoriDaAmbiti() {
    this.spinnerOver.show();

    this.settoriService
      .getSettoriDaAmbiti(this.formTematiche.get('idsAmbiti')?.value || [])
      .subscribe({
        next: (resp) => {
          this.spinnerOver.hide();

          this.arraySettori = (resp || []).filter((sett: Settore) => sett.sottoSettori?.length > 0);

          this.arraySettori.forEach((sett) => {
            sett.sottoSettori?.forEach((sottoSet) => {
              if (sottoSet.id) {
                this.settoriPerIdSottosettore[sottoSet.id] = sett;
              }
            });
          });

          const selezionati = this.formTematiche.get('sottoSettori')?.value;

          this.formTematiche.get('sottoSettori')?.setValue(
            selezionati?.filter((sottoSettSel) => {
              return !!this.arraySettori
                .map((sett) => sett.sottoSettori)
                .flat()
                .find((sottoSett) => sottoSett.id === sottoSettSel.id);
            }) || [],
          );

          this.formTematiche.get('sottoSettori')?.updateValueAndValidity();

          if (!this.isTematicaAziendale) {
            this.formControlChipSottoSettori.setValue(
              this.inputSottoSettori.nativeElement.value || '',
            );
          }
        },
        error: (err: any) => {
          this.spinnerOver.hide();
          console.error('Errore durante il caricamento sottoSettori:', err);

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: 'Errore nel recupero sotto-settori',
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
  }

  rimuoviSottoSettore(sottoSettore: SottoSettore) {
    if (sottoSettore) {
      const selezionati = (this.formTematiche.get('sottoSettori')?.value || []).filter(
        (sottoSet: SottoSettore) => sottoSet.id !== sottoSettore.id,
      );
      this.formTematiche.get('sottoSettori')?.setValue(selezionati);
    }
  }

  selezionaSottoSettore(event: MatAutocompleteSelectedEvent) {
    if (this.formTematiche.get('sottoSettori') && event?.option?.value) {
      const selezionati = this.formTematiche.get('sottoSettori')!.value || [];

      const trovato = selezionati.find(
        (sottoSett: SottoSettore) => sottoSett.id === event.option.value.id,
      );

      if (!trovato) {
        selezionati.push(event.option.value);
        this.formTematiche.get('sottoSettori')!.setValue(selezionati);
      }
    }

    this.inputSottoSettori.nativeElement.value = '';

    this.formControlChipSottoSettori.setValue(null);
  }

  onSelectionChangeAree(event: MatSelectChange) {
    if (event.value.includes('survey')) {
      this.areaSelezionata = true;
    } else {
      this.areaSelezionata = false;
    }
  }

  /**
   * Metodo che mi crea un oggetto per visualizzare i dati nel componente di chip
   * @param getTags
   * @returns
   */
  private metodoGetTagsPerChip(getTags: any) {
    return (ricerca: string | undefined, elementiPreSelezionati?: string[]) =>
      this.utilityService._getTagsPerFiltro(ricerca, elementiPreSelezionati, getTags).pipe(
        map((tags: string[]) =>
          tags.map((tag, index) => ({
            id: index,
            descrizione: tag,
          })),
        ),
      );
  }

  public apriFiltroSelezionati(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      impatti: () =>
        this._configuraFiltri(
          'titoloFiltroSelezione',
          'tagFiltroSelezione',
          this.metodoGetTagsPerChip(this.impattoService.getImpattiTags(0, 1000)),
        ),
      impegni: () =>
        this._configuraFiltri(
          'titoloFiltroSelezione',
          'tagFiltroSelezione',
          this.metodoGetTagsPerChip(this.impegniService.getImpegniTags(0, 1000)),
        ),
      azioni: () =>
        this._configuraFiltri(
          'titoloFiltroSelezione',
          'tagFiltroSelezione',
          this.metodoGetTagsPerChip(this.azioniBPService.getAzioneBPTags(0, 1000)),
        ),
      kpi: () =>
        this._configuraFiltri(
          'descrizioneFiltroSelezione',
          'tagFiltroSelezione',
          this.metodoGetTagsPerChip(this.kpiService.getKPITags(0, 1000)),
        ),
      certificazioni: () =>
        this._configuraFiltriCertificazioni(
          'nomeBreveFiltroSelezione',
          'descrizioneFiltroSelezione',
        ),
      obiettivi: () =>
        this._configuraFiltriObiettivi('titoloFiltroSelezione', 'descrizioneFiltroSelezione'),
      esrs: () =>
        this._configuraFiltriEsrs('nomeBreveFiltroSelezione', 'descrizioneFiltroSelezione'),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltroSelezionati,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltroSelezionati = result.filtri;

        this.getElementiSelezionati(filtroFrom);
      }
    });
  }

  getElementiSelezionati(formName: string) {
    if (!this._valoriFiltroSelezionati.length) {
      this.rimpiArraySelezionati(formName);
    } else {
      let arrayFiltrato: any;

      switch (formName) {
        case 'impatti':
          arrayFiltrato = this.arrayImpattiSel;
          break;
        case 'impegni':
          arrayFiltrato = this.arrayImpegniSel;
          break;
        case 'azioni':
          arrayFiltrato = this.arrayAzioneBPSel;
          break;
        case 'kpi':
          arrayFiltrato = this.arrayKpiSel;
          break;
        case 'certificazioni':
          arrayFiltrato = this.arrayCertificazioniSel;
          break;
        case 'obiettivi':
          arrayFiltrato = this.arrayObiettiviSel;
          break;
        case 'esrs':
          arrayFiltrato = this.arrayEsrsSel;
          break;
        default:
          break;
      }

      if (!arrayFiltrato) {
        return;
      }

      arrayFiltrato = arrayFiltrato.filter((elemento: any) => {
        return this._valoriFiltroSelezionati.every((valoreFiltro) => {
          if (valoreFiltro.chiave === 'titoloFiltroSelezione') {
            return elemento.titolo.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il titolo include il valore
          } else if (valoreFiltro.chiave === 'descrizioneFiltroSelezione') {
            return elemento.descrizione
              .toLowerCase()
              .includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il descrizione include il valore
          } else if (valoreFiltro.chiave === 'tagFiltroSelezione') {
            return valoreFiltro.values.some((valore) => elemento.tag?.includes(valore)); // Controlla se uno dei tag corrisponde
          } else if (valoreFiltro.chiave === 'nomeBreveFiltroSelezione') {
            return elemento.nomeBreve.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se il nome breve include il valore
          }
          return true; // Se il filtro non corrisponde a nessuna chiave, non filtrare
        });
      });

      switch (formName) {
        case 'impatti':
          this.arrayImpattiSelFiltrati = arrayFiltrato;
          break;
        case 'impegni':
          this.arrayImpegniSelFiltrati = arrayFiltrato;
          break;
        case 'azioni':
          this.arrayAzioneBPSelFiltrati = arrayFiltrato;
          break;
        case 'kpi':
          this.arrayKpiSelFiltrati = arrayFiltrato;
          break;
        case 'certificazioni':
          this.arrayCertificazioniSelFiltrati = arrayFiltrato;
          break;
        case 'obiettivi':
          this.arrayObiettiviSelFiltrati = arrayFiltrato;
          break;
        case 'esrs':
          this.arrayEsrsSelFiltrati = arrayFiltrato;
          break;
        default:
          break;
      }
    }
  }

  /**
   * Riempio l'array selezionati se faccio cancella filtri
   * @param formName
   */
  rimpiArraySelezionati(formName: string) {
    switch (formName) {
      case 'impatti':
        this.arrayImpattiSelFiltrati = [...this.arrayImpattiSel];

        break;
      case 'impegni':
        this.arrayImpegniSelFiltrati = [...this.arrayImpegniSel];
        break;
      case 'azioni':
        this.arrayAzioneBPSelFiltrati = [...this.arrayAzioneBPSel];
        break;
      case 'kpi':
        this.arrayKpiSelFiltrati = [...this.arrayKpiSel];
        break;
      case 'certificazioni':
        this.arrayCertificazioniSelFiltrati = [...this.arrayCertificazioniSel];
        break;
      case 'obiettivi':
        this.arrayObiettiviSelFiltrati = [...this.arrayObiettiviSel];
        break;
      case 'esrs':
        this.arrayEsrsSelFiltrati = [...this.arrayEsrsSel];
        break;
      default:
        break;
    }
  }

  public apriFiltro(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      impatti: () =>
        this._configuraFiltri(
          'titolo',
          'tag',
          this.metodoGetTagsPerChip(this.impattoService.getImpattiTags(0, 1000)),
        ),
      impegni: () =>
        this._configuraFiltri(
          'titolo',
          'tag',
          this.metodoGetTagsPerChip(this.impegniService.getImpegniTags(0, 1000)),
        ),
      azioniBP: () =>
        this._configuraFiltri(
          'titolo',
          'tag',
          this.metodoGetTagsPerChip(this.azioniBPService.getAzioneBPTags(0, 1000)),
        ),
      kpi: () =>
        this._configuraFiltri(
          'descrizione',
          'tag',
          this.metodoGetTagsPerChip(this.kpiService.getKPITags(0, 1000)),
        ),
      certificazioni: () => this._configuraFiltriCertificazioni('nomeBreve', 'descrizione'),
      obiettivi: () => this._configuraFiltriObiettivi('titolo', 'descrizione'),
      esrs: () => this._configuraFiltriEsrs('nomeBreve', 'descrizione'),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltro,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltro = result.filtri;

        switch (filtroFrom) {
          case 'impatti':
            this._getImpatti();
            break;
          case 'impegni':
            this._getImpegni();
            break;
          case 'azioniBP':
            this._getAzioniBP();
            break;
          case 'kpi':
            this._getkPI();
            break;
          case 'certificazioni':
            this._getCertificazioni();
            break;
          case 'obiettivi':
            this._getObiettivi();
            break;
          case 'esrs':
            this._getEsrs();
            break;
          default:
            break;
        }
      }
    });
  }

  private _getImpatti() {
    this.spinnerOver.show();
    this.impattoService
      .getImpatti(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayImpattiDisponibili = esito.content || [];

          this.arrayImpattiDisponibili = this.arrayImpattiDisponibili.filter(
            (impattoSel) => !this.arrayImpattiSel.some((item2) => impattoSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  private _getImpegni() {
    this.spinnerOver.show();
    this.impegniService
      .getImpegni(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayImpegni = esito.content || [];

          //rimuovo gli impegni selezionati da quelli disponibili
          this.arrayImpegni = this.arrayImpegni.filter(
            (impegniSel) => !this.arrayImpegniSel.some((item2) => impegniSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  private _getAzioniBP() {
    this.spinnerOver.show();
    this.azioniBPService
      .getAzioneBP(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayAzioneBP = esito.content || [];

          //rimuovo le azioni e buone pratiche selezionati da quelli disponibili
          this.arrayAzioneBP = this.arrayAzioneBP.filter(
            (azioneSel) => !this.arrayAzioneBPSel.some((item2) => azioneSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
  private _getkPI() {
    this.spinnerOver.show();
    this.kpiService
      .getKPI(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayKpi = esito.content || [];

          //rimuovo kpi selezionati da quelli disponibili
          this.arrayKpi = this.arrayKpi.filter(
            (kpiSel) => !this.arrayKpiSel.some((item2) => kpiSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  private _getCertificazioni() {
    this.spinnerOver.show();
    this.certificazioniService
      .getCert(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayCertificazioni = esito.content || [];
          //rimuovo certificazioni selezionate da quelli disponibili
          this.arrayCertificazioni = this.arrayCertificazioni.filter(
            (certificazioneSel) =>
              !this.arrayCertificazioniSel.some((item2) => certificazioneSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * Metodo che mi ritorna la lista degli obiettivi
   */
  private _getObiettivi() {
    this.spinnerOver.show();
    this.pianoService
      .getObiettivi(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayObiettivi = esito.content || [];
          //rimuovo obiettivi selezionati da quelli disponibili
          this.arrayObiettivi = this.arrayObiettivi.filter(
            (obiettivoSel) => !this.arrayObiettiviSel.some((item2) => obiettivoSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  /**
   * Metodo che mi ritorna la lista degli esrs
   */
  private _getEsrs() {
    this.spinnerOver.show();
    this.esrsService
      .getESRS(0, 1000, undefined, this._valoriFiltro)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          this.arrayEsrs = esito.content || [];
          //rimuovo esrs selezionati da quelli disponibili
          this.arrayEsrs = this.arrayEsrs.filter(
            (esrsSel) => !this.arrayEsrsSel.some((item2) => esrsSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  // Prima, definisci un metodo per configurare i filtri comuni:
  private _configuraFiltri(filtro1: string, filtro2: string, metodoService: any) {
    return [
      {
        titolo: filtro1.includes('titolo') ? 'Titolo' : 'Descrizione',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        titolo: 'TAG',
        forControlName: filtro2,
        input: 'multiple-option-chip',
        riempi: true,
        larghezza: 3,
        fnDatiOption: metodoService,
        idValueOption: 'descrizione',
        descValueOption: 'descrizione',
        numeroRecOptions: Infinity,
      },
    ];
  }

  private _configuraFiltriCertificazioni(filtro1: string, filtro2: string) {
    return [
      {
        titolo: 'Nome',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        titolo: 'Descrizione',
        forControlName: filtro2,
        input: 'text',
        riempi: true,
        larghezza: 3,
      },
    ];
  }

  private _configuraFiltriObiettivi(filtro1: string, filtro2: string) {
    return [
      {
        titolo: 'Titolo',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        titolo: 'Descrizione',
        forControlName: filtro2,
        input: 'text',
        riempi: true,
        larghezza: 3,
      },
    ];
  }

  private _configuraFiltriEsrs(filtro1: string, filtro2: string) {
    return [
      {
        titolo: 'Nome Breve',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        titolo: 'Descrizione',
        forControlName: filtro2,
        input: 'text',
        riempi: true,
        larghezza: 3,
      },
    ];
  }
  /**
   * Controllo quali bottoni mostrare per quando si entra in modifica e si apre l'expansion
   * @param elemento
   */
  ctrBottoni(elemento: any) {
    if (!elemento.length) {
      this.isSottoRisp = true;
      this.isKpi = true;
      this.isAzione = true;
    } else {
      elemento.forEach((sottoOpz: any) => {
        if (sottoOpz?.tipo === 'checkbox') {
          this.isSottoRisp = true;
          this.isKpi = false;
          this.isAzione = false;
        } else {
          this.isSottoRisp = false;
          this.isKpi = true;
          this.isAzione = true;
        }
      });
    }
  }
  onKeyDown(event: KeyboardEvent): void {
    // Verifica se il tasto premuto è il carattere "-"
    if (event.key === '-') {
      // Impedisce l'inserimento del carattere "-"
      event.preventDefault();
    }
  }

  /* ----------------------------   CONFIGURAZIONE RISPOSTE PER ASSESSMENT --------------------------------------- */

  public arraySelSuCfgRisposte: any[] = [];

  apriCfgRisposte(
    tipoElemento: string,
    valore: any,
    formArraySottoRisposte: FormArray,
    isVsme: boolean,
  ) {
    this.getArrayEelemSelezionati(formArraySottoRisposte, tipoElemento);

    const dialogCfgRisposteTematica = this.dialog.open(DialogCfgRisposteTematicaComponent, {
      data: {
        elemento: tipoElemento,
        titolo: valore.value,
        arraySelezioinati: this.arraySelSuCfgRisposte,
        isVsme: isVsme,
      },
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '80%',
      maxHeight: '95%',
      height: '100%',

      autoFocus: false,
    });

    dialogCfgRisposteTematica.afterClosed().subscribe((result) => {
      if (result) {
        if (tipoElemento === 'kpi') {
          this.mappaKpidaEsterno(result, formArraySottoRisposte, isVsme);
        }
        if (tipoElemento === 'azione') {
          this.mappaAzioniBPdaEsterno(result, formArraySottoRisposte, isVsme);
        }
      }
    });
  }

  apriCfgTabella(
    tipoElemento: string,
    valore: any,
    formArraySottoRisposte: FormArray,
    isVsme: boolean,
    indexElemento?: number,
  ) {
    this.getArrayEelemSelezionati(formArraySottoRisposte, tipoElemento);

    let tabella: TabellaDinamica | undefined;

    // Prendo i valori dal formarray per passare l'oggetto da aggiornare
    if (indexElemento != undefined) {
      tabella = {
        id: formArraySottoRisposte.controls[indexElemento].value.valore.id,
        colonne: formArraySottoRisposte.controls[indexElemento].value.valore.colonne,
        righe: formArraySottoRisposte.controls[indexElemento].value.valore.righe,
        totaleColonne: formArraySottoRisposte.controls[indexElemento].value.valore.totaleColonne,
        totaleRighe: formArraySottoRisposte.controls[indexElemento].value.valore.totaleRighe,
        titoloTabella: formArraySottoRisposte.controls[indexElemento].value.valore.titoloTabella,
      };
    }

    const dialogCfgRisposteTematica = this.dialog.open(DialogCreaTabellaDinamicaComponent, {
      data: {
        isConfigurazione: true,
        tabella: tabella ?? undefined,
      },
      panelClass: ['dialog-container-scrollbar'],
      disableClose: false,
      width: '80%',
      maxHeight: '95%',
      height: '100%',

      autoFocus: false,
    });

    dialogCfgRisposteTematica.afterClosed().subscribe((result) => {
      if (result) {
        this.mappaTabellaDaEsterno(result, formArraySottoRisposte, indexElemento);
      }
    });
  }

  /**
   * Mi mappo nel oggetto corretto i kpi selezionate nella configurazione risposta
   * @param opzione
   * @param formArraySottoRisposte
   */
  public mappaKpidaEsterno(opzione: any, formArraySottoRisposte: FormArray, isVsme: boolean) {
    // Crea un array temporaneo per i nuovi FormGroup di tipo 'kpi'
    const nuoviKpiFormGroup: FormGroup[] = [];

    // Salvo i dati referiti al moduloCompleto
    let hashMapModuloCompleto: { [id: string]: boolean } = {};
    if (isVsme) {
      hashMapModuloCompleto = this.hashMapModuloCompleto(formArraySottoRisposte);
    }

    // Itera su 'opzione' per creare nuovi gruppi solo per 'kpi'
    opzione.forEach((elemento: any) => {
      this.isSottoRisp = false;
      this.isKpi = true;
      this.isAzione = false;

      // Crea un nuovo FormGroup per l'elemento di tipo 'kpi'
      const formRisposta = new FormGroup({
        valore: new FormControl<KPI | undefined>(elemento, {
          nonNullable: true,
          validators: [Validators.required, UtilityService.blankValidator],
        }),
        nc: new FormControl<boolean | undefined>(undefined),
        punteggio: new FormControl<number | undefined>(
          elemento.valoreAttribuito,
          isVsme ? [] : [Validators.required],
        ),
        sottoOpzioni: new FormArray([]),
        tipo: new FormControl<string>('kpi'),
        moduloCompleto: new FormControl<boolean>(hashMapModuloCompleto[elemento.id] ?? false),
      });

      // Aggiungi il FormGroup all'array temporaneo
      nuoviKpiFormGroup.push(formRisposta);
    });

    // Mantieni solo gli elementi non di tipo 'kpi' dal FormArray esistente
    const elementiNonKpi = formArraySottoRisposte.controls.filter(
      (formGroup) => formGroup.get('tipo')?.value !== 'kpi',
    );

    // Sostituisci il contenuto del FormArray con gli elementi non 'kpi' e i nuovi 'kpi'
    formArraySottoRisposte.clear();
    elementiNonKpi.forEach((formGroup) => formArraySottoRisposte.push(formGroup)); // Aggiungi gli elementi non 'kpi'
    nuoviKpiFormGroup.forEach((formGroup) => formArraySottoRisposte.push(formGroup)); // Aggiungi i nuovi 'kpi'
  }

  /**
   * Per non perdere il valore "moduloCompleto" sulla sottorisposta mi creo una mappa con idelemento e il valore
   * della suo moduloCompleto. Poi mi valorizzo il form control tramite la mappa cercando il valore per id del elemento
   * Vale per KPI E AZIONI
   * @param formArraySottoRisposte sotto risposte di tipo kpi e azioni
   * @returns
   */
  hashMapModuloCompleto(formArraySottoRisposte: FormArray) {
    const sottoRisposte = formArraySottoRisposte.getRawValue();

    const hashMapModuloCompleto: { [id: string]: boolean } = sottoRisposte.reduce(
      (acc: any, risp: any) => {
        acc[risp.valore.id] = risp.moduloCompleto;
        return acc;
      },
      {},
    );

    return hashMapModuloCompleto;
  }

  /**
   * Mi mappo nel oggetto corretto le azioni selezionate nella configurazione risposta
   * @param opzione
   * @param formArraySottoRisposte
   */
  public mappaAzioniBPdaEsterno(opzione: any, formArraySottoRisposte: FormArray, isVsme: boolean) {
    // Crea un array temporaneo per i nuovi FormGroup di tipo 'azione'
    const nuoviAzioneFormGroup: FormGroup[] = [];

    // Salvo i dati referiti al moduloCompleto
    let hashMapModuloCompleto: { [id: string]: boolean } = {};
    if (isVsme) {
      hashMapModuloCompleto = this.hashMapModuloCompleto(formArraySottoRisposte);
    }

    // Itera su 'opzione' per creare nuovi gruppi solo per 'azione'
    opzione.forEach((elemento: any) => {
      this.isSottoRisp = false;
      this.isKpi = false;
      this.isAzione = true;

      // Crea un nuovo FormGroup per l'elemento di tipo 'azione'
      const formRisposta = new FormGroup({
        valore: new FormControl<AzioneBP | undefined>(elemento, {
          nonNullable: true,
          validators: [Validators.required, UtilityService.blankValidator],
        }),
        nc: new FormControl<boolean | undefined>(undefined),
        punteggio: new FormControl<number | undefined>(
          elemento.valoreAttribuito,
          isVsme ? [] : [Validators.required],
        ),
        sottoOpzioni: new FormArray([]),
        tipo: new FormControl<string>('azione'),
        moduloCompleto: new FormControl<boolean>(hashMapModuloCompleto[elemento.id] ?? false),
      });

      // Aggiungi il FormGroup all'array temporaneo
      nuoviAzioneFormGroup.push(formRisposta);
    });

    // Mantieni solo gli elementi non di tipo 'azione' dal FormArray esistente
    const elementiNonAzione = formArraySottoRisposte.controls.filter(
      (formGroup) => formGroup.get('tipo')?.value !== 'azione',
    );

    // Sostituisci il contenuto del FormArray con gli elementi non 'azione' e i nuovi 'azione'
    formArraySottoRisposte.clear();
    elementiNonAzione.forEach((formGroup) => formArraySottoRisposte.push(formGroup)); // Aggiungi gli elementi non 'azione'
    nuoviAzioneFormGroup.forEach((formGroup) => formArraySottoRisposte.push(formGroup)); // Aggiungi i nuovi 'azione'
  }

  /**
   * Mi mappo nel oggetto corretto la tabella configurata
   * @param opzione
   * @param formArraySottoRisposte
   * @param indexElemento indice dell'elemento sotto modifica
   */
  public mappaTabellaDaEsterno(
    opzione: any,
    formArraySottoRisposte: FormArray,
    indexElemento?: number,
  ) {
    //Se sono in modifica allora sostituisco semplicemente l'elemento modificato nella form
    if (indexElemento != undefined) {
      const valore = new FormControl<TabellaDinamica | undefined>(opzione, {
        nonNullable: true,
        validators: [Validators.required, UtilityService.blankValidator],
      });

      const gruppoEsistente = formArraySottoRisposte.at(indexElemento) as FormGroup;
      gruppoEsistente.setControl('valore', valore);
    } else {
      // Crea un nuovo FormGroup per l'elemento di tipo dynamic_table
      const formRisposta = new FormGroup({
        valore: new FormControl<TabellaDinamica | undefined>(opzione, {
          nonNullable: true,
          validators: [Validators.required, UtilityService.blankValidator],
        }),
        nc: new FormControl<boolean | undefined>(undefined),
        sottoOpzioni: new FormArray([]),
        tipo: new FormControl<string>('dynamic_table'),
        moduloCompleto: new FormControl<boolean>(false),
        /*   id: new FormControl<string | undefined>(undefined), */
      });

      formArraySottoRisposte.push(formRisposta); // Aggiungi le nuove tabelle
    }
  }

  /**
   * Metodo che mi valorizza l'array degli elementi selezionati in configurazione della risposta
   * @param formArraySottoRisposte oggetto con gli elementi
   * @param tipoElemento tipo elemento, se kpòi o azione
   */
  getArrayEelemSelezionati(formArraySottoRisposte: FormArray, tipoElemento: string) {
    this.arraySelSuCfgRisposte = [];

    formArraySottoRisposte.value.forEach((elem: any) => {
      if (elem.tipo.toLowerCase() === tipoElemento.toLowerCase()) {
        this.arraySelSuCfgRisposte.push({
          ...elem.valore,
          valoreAttribuito: elem.punteggio,
        });
      }
    });
  }

  /**
   * True se selezionato VSME
   * @returns
   */
  isVsme(): boolean {
    const stdr = this.stdr.getRawValue();
    const compliance = this.compliance.getRawValue();

    if (
      stdr?.some((stdr) => stdr.nomePadre === 'VSME' && stdr.selected) ||
      compliance?.some((comp) => comp.nomePadre === 'VSME' && comp.selected)
    ) {
      return true;
    }

    return false;
  }

  /**
   * Bottom sheet per inserire la norma sulla risposta (chiave -> risposteVSME)
   * @param codiceNormaVsme FormControl
   * @param descrizioneNormaVsme FormControl
   */
  apriBottomSheetNorma(
    codiceNormaVsme: FormControl,
    descrizioneNormaVsme: FormControl,
    risposta: string,
  ) {
    const objNorma: NormaRispostaVsme = {
      codiceNormaVsme: codiceNormaVsme.getRawValue(),
      descrizioneNormaVsme: descrizioneNormaVsme.getRawValue(),
    };

    const normaBottomSheet = this._bottomSheet.open(NormaVsmeBottomsheetComponent, {
      data: {
        normaRisposta: objNorma,
        risposta: risposta,
      },
    });

    normaBottomSheet.afterDismissed().subscribe((esito: NormaRispostaVsme) => {
      if (esito) {
        codiceNormaVsme.setValue(esito.codiceNormaVsme);
        descrizioneNormaVsme.setValue(esito.descrizioneNormaVsme);
      }
    });
  }

  /**
   * Aggiorna tutti i controlli 'moduloCompleto' dei figli (sottoOpzioni)
   * impostandoli sul valore del checkbox padre.
   *
   * @param checked - Stato del checkbox padre (true = selezionato, false = deselezionato)
   * @param risposte - Il FormGroup principale che contiene il FormArray 'sottoOpzioni'
   */
  updateAllChild(checked: boolean, risposte: FormGroup) {
    const sottoOpzioni: FormArray = risposte.get('sottoOpzioni') as FormArray;

    sottoOpzioni.controls.forEach((stOpz: AbstractControl) => {
      const formStOpz = stOpz as FormGroup;

      formStOpz.get('moduloCompleto')?.setValue(checked);
    });
  }

  /**
   * Verifica se tutte le sottoOpzioni di un FormGroup hanno il campo 'moduloCompleto' selezionato.
   * Se tutte sono true, imposta anche il valore del campo 'moduloCompleto' del gruppo padre su true.
   * Altrimenti su false
   *
   * @param risposte - Il FormGroup principale che contiene il FormArray 'sottoOpzioni'
   * @returns {boolean} true se tutte le sottoOpzioni sono selezionate, altrimenti false
   */
  isAllChecked(risposte: FormGroup): boolean {
    const sottoOpzioni: FormArray = risposte.get('sottoOpzioni') as FormArray;
    if (!sottoOpzioni || sottoOpzioni.length === 0) return false;

    const sottoOpzioniValue = sottoOpzioni.getRawValue();

    const isChecked = sottoOpzioniValue.every((sotto: any) => !!sotto.moduloCompleto);

    risposte.get('moduloCompleto')?.setValue(isChecked);

    return isChecked;
  }

  /**
   * Metodo ti esportazione tab VSME
   */
  public exportTabVsme() {
    this.spinnerOver.show();

    this.tematicheService
      .exportTabVsme(this.idTematica)
      .pipe(finalize(() => this.spinnerOver.hide()))
      .subscribe({
        next: (esito) => {
          console.log(esito);
          if (esito.file) {
            this.utilityService.downloadExcel(esito.file, 'Exported_CfgVSME');
            this.utilityService.openSnackBar(`Esportazione completata`, '', {
              duration: 3000,
              panelClass: ['success-snackbar'],
            });
          }
        },
        error: (error) => {
          console.error(error);
          this.utilityService.openSnackBar(`Esportazione non riuscita`, '', {
            duration: 3000,
            panelClass: ['red-snackbar'],
          });
        },
      });
  }

  /**
   * Metodo chiamato da html per la dialog prompt ai
   * prima salvo l'oggetto e poi apri la dialog
   */
  protected async ctrOpenPromptAI() {
    if (!this.idTematica) {
      await this.salva();
    }
    if (this.idTematica) {
      this.promptAI('TEMATICA', this.idTematica);
    }
  }

  /**
   * Dialog per inserimneto prompt
   */
  private promptAI(tipoElemento: TipoElemento, idElemento: string) {
    const dialogPromptAi = this.dialog.open(DialogPromptAiComponent, {
      data: {
        tipoElemento,
        idElemento: idElemento,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogPromptAi.afterClosed().subscribe((result) => {
      //
    });
  }

  /**
   * Esegue il prompt AI per una sotto-risposta specifica.
   * Se l'elemento non è presente, salva prima il form e poi riesegue la ricerca,
   * poichè quando si ricrea il form, i dati precedenti e i riferimenti si perdono.
   *
   * @param indexRisposta - Indice della risposta principale nell'array 'risposteVsme'.
   * @param indexSottoRisp - Indice della sotto-risposta nell'array 'sottoOpzioni'.
   */
  protected async promptAiSottoRisp(indexRisposta: number, indexSottoRisp: number): Promise<void> {
    // helper per reperire il valore della sotto risposta dopo l'update della form
    const getSottoRispFormGroup = (responseIndex: number, subIndex: number): FormGroup => {
      const formArray = this.formTematiche.get('risposteVsme') as FormArray;
      return ((formArray.at(responseIndex) as FormGroup).get('sottoOpzioni') as FormArray).at(
        subIndex,
      ) as FormGroup;
    };

    let sottorisp = getSottoRispFormGroup(indexRisposta, indexSottoRisp);
    let { tipo, valore, id } = sottorisp.getRawValue();
    let idElemento = this.getIdElementoByTipo(tipo, valore, id);

    // Se l'elemento non esiste, salvo la tematica e recupero nuovamente la sotto-risposta
    if (!idElemento) {
      await this.salva();
      sottorisp = getSottoRispFormGroup(indexRisposta, indexSottoRisp);
      ({ tipo, valore, id } = sottorisp.getRawValue());
      idElemento = this.getIdElementoByTipo(tipo, valore, id);
    }

    const tipoElementoForPrompt = this.convertTipoElementoForPrompt(tipo);
    // Se esiste l'id elemento allora apro la cfg prompt
    if (idElemento) {
      this.promptAI(tipoElementoForPrompt, idElemento);
    }
  }

  /**
   * Restituisce l'id dell'elemento associato alla sottorisposta
   * in base al tipo.
   *
   * @param tipo Tipo della sottorisposta
   * @param valore Valore della sottorisposta
   * @param id Id della sottorisposta
   * @returns Id dell'elemento o undefined se non determinabile
   */
  private getIdElementoByTipo(
    tipo: string,
    valore: any,
    id: string | undefined,
  ): string | undefined {
    if (tipo !== 'checkbox') {
      return valore?.id;
    }
    return id;
  }

  /**
   * Mi restitusce il tipo dell'elenmento con la tipizzazione del @TipoElemento per il prompt ai
   * @param tipo tipo elemento non di tipo @TipoElemento
   * @returns
   */
  private convertTipoElementoForPrompt(tipo: string): TipoElemento {
    if (tipo === 'dynamic_table' || tipo === 'checkbox') {
      return 'SOTTORISPOSTA';
    }
    return tipo.toUpperCase() as TipoElemento;
  }

  public importTabVsme() {
    const dialogImportaTabVsme = this.dialog.open<
      DialogImportazioneExcelComponent,
      DialogImportazioneData
    >(DialogImportazioneExcelComponent, {
      data: {
        titoloImportazione: 'Importazione Tab VSME',
        subTitoloImportazione:
          'Scarica il file di template excel o fai una nuova importazione della Tab VSME',
        tipoElemento: 'tabVsme',
        azienda: false,
        nomeImport: 'tabVsme',
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      maxWidth: '90%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogImportaTabVsme.afterClosed().subscribe((result) => {
      /* this.tabella.caricaDati(); */
    });
  }

  private setIdAziendaInTematica() {
    const idAzienda = this.data?.idAzienda;
    const tematicaIdAzienda = this.data?.tematica?.idAzienda;

    if (idAzienda && !tematicaIdAzienda) {
      this.formTematiche.get('idAzienda')?.setValue(idAzienda);
    }
  }

  private manageTematicaAziendale() {
    const idAzienda = this.data?.idAzienda;
    const tematicaIdAzienda = this.data?.tematica?.idAzienda;

    const isDuplicaTematica = idAzienda && this.data?.tematica && !tematicaIdAzienda;

    const areeTematicaLength = this.formTematiche.get('aree')?.value.length || 0;

    // Controllo se la tematica va ricreata oppure no
    if (isDuplicaTematica) {
      this.data.tematica.id = '';
      this.formTematiche.get('id')?.setValue('');
    }

    // Sono in creazione nuova di una tematica aziendale (dentro un modulo)
    if (!isDuplicaTematica && !tematicaIdAzienda) {
      // Setto l'id dell'ambito dove vado a creare la tematica
      this.formTematiche.controls.idsAmbiti.setValue(
        this.data.idAmbito ? [this.data.idAmbito] : [],
      );
      this.formTematiche.get('idsAmbiti')?.disable();
      /*     this.formTematiche.get('index')?.updateValueAndValidity(); */
    }

    // Inserisco tutte le chiavi delle aree nel form
    if (this.isTematicaAziendale && areeTematicaLength < this.arrayAree.length) {
      const chiaviAree =
        this.arrayAree
          ?.filter(
            (area: AreeTematica) => area.chiave !== 'autovalutazioni' && area.chiave !== 'survey',
          )
          .map((area: AreeTematica) => area.chiave) || [];

      this.formTematiche.get('aree')?.setValue(chiaviAree);
    }

    // Controllo post-inserimento: rimuovo autovalutazioni o survey se presenti
    const areeSelezionate: string[] = this.formTematiche.get('aree')?.value || [];
    if (areeSelezionate.includes('autovalutazioni') || areeSelezionate.includes('survey')) {
      const areeFiltrate = areeSelezionate.filter(
        (chiave) => chiave !== 'autovalutazioni' && chiave !== 'survey',
      );
      this.formTematiche.get('aree')?.setValue(areeFiltrate);
    }

    if (idAzienda && this.isTematicaAziendale) {
      this.formTematiche.get('nomeBreve')?.clearValidators();
      this.formTematiche.get('index')?.clearValidators();
      this.formTematiche.get('nomeBreve')?.updateValueAndValidity();
      this.formTematiche.get('index')?.updateValueAndValidity();
    }
  }

  protected closeDialog() {
    if (this.isTematicaAziendale) {
      this.dialogRef.close({ idsAmbiti: this.formTematiche.get('idsAmbiti')?.value });
    } else {
      this.dialogRef.close();
    }
  }
}
